import React, { useState, useEffect } from 'react';
import { Row, Button, Col } from 'reactstrap';
import { colors } from 'config/colors';
import { routes, modals } from 'config/appConfig';
import { useRouterTransition } from 'hooks/useRouterTransition';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const CustomButton = ({ color, label, onClick, textSize, disabled, buttonSize, fullWidth, icon, iconCenter, portal, id, timer, modal }) => {

  const [isPressed, setIsPressed] = useState(false);
  const [isTiming, setIsTiming] = useState(timer ? true : false);
  const { pathname } = useLocation();
  const url = pathname;
  const [delay, setDelay] = useState(timer ? true : false);
  const [timeLeft, setTimeLeft] = useState(false);
  const navigate = useNavigate();

  let { handleTransition } = useRouterTransition(navigate);
  const [isInsideButton, setInsideButton] = useState(false);
  const {languageModalOpen,faqsModalOpen,notificationsModalOpen,loading} = useSelector(state => state.appConfig);

  const detectActivity = () => {
    document.addEventListener('touchstart', animationTimer);
    return () => {
      removeActivityListeners()
    }
  };

  const removeActivityListeners = () => {
    document.removeEventListener('touchstart', animationTimer);
  };

  const handleTouchStart = () => {
    setIsPressed(true);
  }

  const handleTouchEnd = () => {
    if (isInsideButton) {
      setIsTiming(false);
    }
    setIsPressed(false);
  };

  const handleTouchMove = (event) => {
    if (timer) {
      const touch = event.touches[0];
      const touchX = touch.clientX;
      const touchY = touch.clientY;
      const buttonRect = event.touches[0]?.target.getBoundingClientRect();

      if (touchX < buttonRect.left || touchX > buttonRect.right || touchY < buttonRect.top || touchY > buttonRect.bottom) {
        setInsideButton(false)
      }
    }
  };

  const navTo = (url, state) => {
    if (state) {
      handleTransition(url, state)
    }
    else {
      handleTransition(url)
    }
  };

  const animationTimer = () => {
    let delay = false;
    setTimeLeft(0);
    if (modal) {
      modals.map((item) => {
        if (languageModalOpen) {
          if ("language" === item?.name) {
            delay = item.inativityTime;
            setDelay(delay * 10);
          }
        }
        if (faqsModalOpen) {
          if ("faqs" === item?.name) {
            delay = item.inativityTime;
            setDelay(delay * 10);
          }
        }
      })
    }
    else {
      routes.map((item) => {
        if (url === item.path) {
          delay = item.inativityTime;
          setDelay(delay * 10);
        }
      });
    }
  };

  useEffect(() => {
    let id;
    if (isTiming) {
      if (timeLeft < delay) {
        if (!loading && !isPressed && !faqsModalOpen && !notificationsModalOpen && !languageModalOpen) {
          id = setInterval(() => {
            setTimeLeft(timeLeft + 1);
          }, 100);
        }
      }
      if (timeLeft === delay) {
        setIsPressed(true);
        setIsTiming(false);
        navTo('/home')
        setInterval(() => {
          setIsPressed(false);
        }, 100);
      }
    }
    return () => clearInterval(id)
  }, [isTiming, timeLeft, delay, loading, isPressed, notificationsModalOpen, faqsModalOpen, languageModalOpen]);


  useEffect(() => {
    detectActivity()
    animationTimer()
    return () => {
      removeActivityListeners()
    }
  }, [])

  return (
    <Row className={fullWidth ? 'm-0 p-0 border-radius' : 'border-radius'}>
      <Col xs="12">
        <Row className='border-radius position-relative overflow-hidden' style={{ height: buttonSize === "small" ? "35px" : "50px" }}>
          <Button
            disabled={disabled}
            color={color}
            className={` ${textSize} border-0 border-radius d-flex justify-content-center align-items-center position-relative w-100`}
            style={{ color:color === "secondary" ? colors.font : colors.white,height: disabled ? "100%" : buttonSize === "small" ? "32px" : "47px", transform: isPressed ? 'translateY(3px)' : 'translateY(0)', transition: "0.2s", zIndex: 3 }}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            onTouchMove={handleTouchMove}
            onClick={onClick}
            id={id}
          >
            <span className='m-0 p-0 me-2'>{(icon && iconCenter) && icon}</span>
            {label}
            {(icon && !iconCenter) &&
              <div className='m-0 p-0 position-absolute' style={{ width: "fit-content", height: "fit-content", left: "15px" }}>
                {icon}
              </div>
            }
          </Button>
          <div className='position-absolute border-radius overflow-hidden'
            style={{
              zIndex: 1,
              bottom: "0px",
              height: disabled ? "0px" : buttonSize === "small" ? "32px" : "47px",
              background: color === "secondary" ? portal ? colors?.secondaryButton_shaddow : colors["cream"]?.dark : colors?.primary_shadow,
            }}
          >
            {(isTiming && delay && timer && color !== "primary") && (
            <div
              className='position-absolute border-radius timerAnim'
              id="timer"
              style={{
                zIndex: 2,
                bottom: '0px',
                height: '3px',
                background: colors?.font,
                width: "100%",
                left: `-${(timeLeft / delay) * 100}%`,
                transition: "left 0.1s linear",
              }}
            />
          )}
          </div>
        </Row>
      </Col>
    </Row>
  );
}

export default CustomButton;
